import { Controller, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
class ProductLineManager extends Controller {
	constructor () {
		super("productLineManager");
	}




	
	getList () {
		"use strict";

		const rd = NousCore.api.createRequest();

		NousCore.api.send("product-line/get-list", rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						Shark.set("productLineList", Shark.getInstanceList("ProductLine", data.items));

						productLineManager.emit("listChanged");
						break;
					case 404:
						productLineManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (productLine) {
		"use strict";

		const rd = NousCore.api.createRequest({ item: productLine.collectData() });
		const action = productLine.guid === "" ? "insert" : "update";

		NousCore.api.send(`product-line/${action}`, rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						productLine.parse(data.items[0]);
						productLine.clean();
						productLineManager.emit("productLineSaved");
						break;
					case 99:
						productLineManager.emit("productLineSaveError");
						break;
				}
			}
		});
	}

	update (productLine) {
		"use strict";

		const rd = NousCore.api.createRequest({ item: productLine.collectData() });

		NousCore.api.send("product-line/update", rd, function (data) {
			console.log(data);

			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						productLine.parse(data.items[0]);
						productLineManager.emit("productLineUpdated");
						break;
					case 404:
						productLineManager.emit("productLineUpdateError");
						break;
				}
			}
		});
	}

}

const productLineManager = new ProductLineManager();

Shark.registerController(productLineManager);
export { productLineManager };
